import { useCallback, useContext, useEffect } from 'react';

import { useFinalizeCreationMutation } from '../generated/graphql';
import { context as dependencyContext } from '../view/context/dependency';

export const useFinalizeCreation = () => {
  const { errorPresenter, graphqlClient } = useContext(dependencyContext);
  const [finalizeCreationMutation, { data, loading, error }] = useFinalizeCreationMutation({
    client: graphqlClient,
  });
  const finalizeCreation = useCallback(
    async (id: string) =>
      finalizeCreationMutation({
        variables: {
          id,
        },
      }),
    [finalizeCreationMutation],
  );
  useEffect(() => {
    if (error) {
      errorPresenter.showAsNonFatal(error);
    }
  }, [errorPresenter, error]);

  return {
    finalizeCreation: finalizeCreation,
    dataCreation: data,
    loadingCreation: loading,
    errorCreation: error,
  };
};
